import React from 'react';
import { Linkedin, Mail, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Agility.AI</h3>
            <p className="text-gray-400">
              Empowering businesses through AI, data analytics, intelligent automation, and custom application development.
            </p>
            <div className="mt-4 flex items-center space-x-2 text-gray-400">
              <Mail size={16} className="flex-shrink-0" />
              <a href="mailto:hello@agilitytech.ai" className="hover:text-white transition-colors">
                hello@agilitytech.ai
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/careers" className="text-gray-400 hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/insights" className="text-gray-400 hover:text-white transition-colors">Blog & Insights</Link></li>
              <li><Link to="/case-studies" className="text-gray-400 hover:text-white transition-colors">Case Studies</Link></li>
              <li><Link to="/industries" className="text-gray-400 hover:text-white transition-colors">Industries</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Solutions</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/solutions/artificial-intelligence"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  AI & Machine Learning
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/automation"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Automation
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/data-engineering"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Data Engineering
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/web-mobile-development"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Web & Mobile Dev
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/ai-analytics"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  AI Analytics
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/ai-implementation-services" className="text-gray-400 hover:text-white transition-colors">AI Implementation</Link></li>
              <li><Link to="/generative-ai-consulting" className="text-gray-400 hover:text-white transition-colors">Generative AI</Link></li>
              <li><Link to="/hire-ai-developers" className="text-gray-400 hover:text-white transition-colors">Hire AI Developers</Link></li>
              <li><Link to="/ai-consulting-healthcare" className="text-gray-400 hover:text-white transition-colors">Healthcare AI</Link></li>
              <li><Link to="/ai-consulting-insurance" className="text-gray-400 hover:text-white transition-colors">Insurance AI</Link></li>
              <li><Link to="/ai-consulting-logistics" className="text-gray-400 hover:text-white transition-colors">Logistics AI</Link></li>
              <li><Link to="/ai-consulting-india" className="text-gray-400 hover:text-white transition-colors">AI Consulting India</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Connect</h4>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/agilitytech/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Linkedin size={24} />
              </a>
              <a
                href="https://www.youtube.com/@agility_tech"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Youtube size={24} />
              </a>
              <a
                href="https://x.com/NiharThakkar_"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (Twitter)"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="https://www.reddit.com/user/NiharThakkar/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Reddit"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Clutch Rating Section */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} Agility.AI Technologies. All rights reserved.
              </p>
            </div>
            <div className="flex items-center space-x-3">
              <span className="text-gray-400 text-sm">Rated on Clutch:</span>
              <a 
                href="https://clutch.co/profile/agility-3" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity flex items-center space-x-2"
              >
                <div className="flex items-center space-x-1">
                  <span className="text-2xl font-bold text-white">5</span>
                  <span className="text-xl">⭐</span>
                </div>
                <img
                  src="/image copy copy copy copy copy copy copy copy copy.png"
                  alt="Clutch Logo"
                  className="h-8 w-auto ml-2"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;